import type { LeadsColumnCategoryDto, TableColumnTypeDto } from "app/pages/sales-intelligence/modules/leads-search";

import type { BaseColumnType, ColumnTransformConfig } from "../../types/columns";
import type { TableColumnType } from "../../types/table";

import type { IColumnsService } from "./types";

export const createColumnsService = (): IColumnsService => {
    const dynamicColumnType: ReadonlySet<LeadsColumnCategoryDto> = new Set<LeadsColumnCategoryDto>([
        "signals",
        "technologies",
    ]);

    const isDynamicColumn = <Column extends BaseColumnType = TableColumnType>(column: Column): boolean => {
        return dynamicColumnType.has(column.category as LeadsColumnCategoryDto);
    };

    const transformColumns = <Output, Column extends BaseColumnType = TableColumnTypeDto>(
        columns: readonly Column[],
        config: ColumnTransformConfig<Output, Column>,
    ): readonly Output[] => {
        const { adapter } = config;

        return columns.flatMap((column): Output[] => {
            const result = adapter(column);

            if (Array.isArray(result)) {
                return result as Output[];
            }

            return result ? [result as Output] : [];
        });
    };

    return {
        transformColumns,
        isDynamicColumn,
    };
};
